import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1em;
`;

const StarContainer = styled.div`
  display: flex;
  flex-direction: row-reverse; /* Reverses the order of stars */
`;

StarRating.propTypes = {
  maxRating: PropTypes.number,
  defaultRating: PropTypes.number,
  size: PropTypes.number,
  className: PropTypes.string,
  onSetRating: PropTypes.func,
  clickable: PropTypes.bool,
};

export default function StarRating({
  maxRating = 4,
  size = 15,
  className = "",
  defaultRating = 0,
  onSetRating = () => {},
  clickable = true,
}) {
  const [rating, setRating] = useState(defaultRating);

  useEffect(() => {
    setRating(defaultRating);
  }, [defaultRating]);

  function handleRating(newRating) {
    if (clickable) {
      setRating(newRating);
      onSetRating(newRating);
    }
  }

  function getStarColor() {
    switch (rating) {
      case 4:
        return "#ef233c"; // Red for rating 4
      case 3:
        return "#ff8c00"; // Orange for rating 3
      case 2:
        return "#fae588"; // Yellow for rating 2
      case 1:
      default:
        return "var(--color-witron-blue)"; // Blue for rating 1
    }
  }

  return (
    <Container className={className}>
      <StarContainer>
        {Array.from({ length: maxRating }, (_, i) => (
          <Star
            key={i}
            full={rating >= i + 1}
            onRate={() => handleRating(i + 1)}
            color={getStarColor()}
            size={size}
            clickable={clickable}
          />
        ))}
      </StarContainer>
    </Container>
  );
}

const StarWrapper = styled.span`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: block;
  cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};

  svg {
    width: 100%;
    height: 100%;
    fill: ${({ full, color }) => (full ? color : "none")};
    stroke: ${({ color }) => color};
  }
`;

function Star({ onRate, full, color, size, clickable }) {
  return (
    <StarWrapper
      role="button"
      onClick={onRate}
      // full={full}
      color={color}
      size={size}
      // clickable={clickable}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    </StarWrapper>
  );
}

Star.propTypes = {
  onRate: PropTypes.func,
  full: PropTypes.bool,
  color: PropTypes.string,
  size: PropTypes.number,
  clickable: PropTypes.bool,
};
